// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1u0xl","inputDescription":"styles_inputDescription__1laKj"};